import { useState, useEffect } from 'react'
import { Form, Button, Row, Col, Modal } from 'react-bootstrap'
import { useRouter } from 'next/router';
import { Request } from '@group-devs/yfp7-global-modules'
import Authenticator from '@group-devs/yfp7-authenticator'

import Recaptcha from '../general/Recaptcha';

const request = new Request(process.env.apiDomain)

const SignUpForm = (props) => {

    let site = props.global.site

    const { data: ownerAccount } = request.account.swrAccountProfile(site ? site.accountId : '')

    const router = useRouter()
    const [verified, setVerified] = useState(false)
    const [validationUrl, setValidationUrl] = useState('')
    const [formData, setFormData] = useState({
        firstname: '',  
        lastname: '',
        email: '',
    })
    const [errorMsg, setErrorMsg] = useState({})

    useEffect(() => {
        const host = new URL(window.location.href)
        let url  = new URL(`${host.protocol}//${host.host}/api/post`)
        url.searchParams.append('action', 'optin')
        setValidationUrl(url)
    }, [])

    const handleChange = async (e) => {
        const value = e.target.value
        const name = e.target.name
        setFormData({
        ...formData,
          [name]: value
        })

        setErrorMsg({
            ...errorMsg,
            [name]: [await validateField(name, value)]
        })
    }

    const handleVerification = verified => {
        setErrorMsg({ ['recaptcha']: [] })
        setVerified(verified)
    }

    const validateForm = async () => {
        let formErrors = {};

        for (const field in formData) {
            if (formData.hasOwnProperty(field)) {
                const errors = await validateField(field, formData[field]);
                if (errors.length) formErrors = { ...formErrors, [field]: errors }
            }
        }

        if (Object.keys(formErrors).length === 0) {
            return true;
        }

        setErrorMsg((prevErrors) => ({ ...prevErrors, ...formErrors }));
        return false;
    };

    const validateField = async (field, value) => {
        let ers = [];

        const validateText = (fieldName) => {
            if (value.length === 0) {
                ers.push(`${fieldName} is required`);
            } else if (!/^[A-Za-z ]+$/.test(value)) {
                ers.push('Numbers are not allowed')
                ers.push('Special characters are not allowed')
            }
        };

        const validateEmail = async () => {
            if (value.length === 0) {
                ers.push('Email is required')
            } else if (!/^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(value)) {
                ers.push('Please input a valid email')
            } else if (!/^(?:(?!example|test).)*$/.test(value)) {
                ers.push('"example" and "test" are not allowed')
            } else {
                const res = await request.contacts.swrContact(value, false)
                if (res && res.email)
                    ers.push('Email already exists');
            }
        };

        switch (field) {
            case 'firstname':
                validateText('First Name');
                break;
            case 'lastname':
                validateText('Last Name');
                break;
            case 'email':
                await validateEmail();
                break;
            default:
                return [];
        }

        return ers;
    };

    const fetchResponseErrors = (responseErr) => {
        setErrorMsg({ ...errorMsg, ...responseErr[0] });
    }

    async function onSubmit () {

        if (!verified) {
            setErrorMsg({...errorMsg, ['recaptcha']: ['Required.']})
            return false;
        }
        
        if (await validateForm()) {
            const metaDataDetails = {
                code: site.site.code,
                name: site.site.name
            }

            const post = {
                ...formData, 
                websiteId: site.websiteId,
                meta_data: Buffer.from(JSON.stringify(metaDataDetails)).toString('base64'),
                userId: ownerAccount ? ownerAccount.userId : ''
            }

            const _response = await fetch(validationUrl, {
                method: 'POST',
                headers: Authenticator.getJSONHeaders(),
                body: JSON.stringify(post)
              })
              .then((response) => { return response.json() })
              .catch(function(error) { console.log(error) })

              const newResponse = JSON.parse(_response);

              if (typeof newResponse === 'object'){
                if (newResponse.code === 200) {
                    router.push("/7big-secrets-to-180/confirmation")
                } else {
                    fetchResponseErrors(newResponse.error);
                }
            }
        }
    }
    
return (
    <>
    <Modal {...props} size="lg" aria-labelledby="wyd-modal" className="section-modal-download">
        <Modal.Header closeButton>
            <Modal.Title id="wyd-modal"></Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Form>
            <Row>
                <Col md={5}>
                    <h3 className="text-center">Fill in the form to get the special report for free!</h3>
                </Col>
                <Col md={7}>
                    <Form.Group controlId="firstname">
                        <Form.Control
                            type="text"
                            placeholder="Enter your First Name.."
                            name="firstname"
                            value={formData.firstname}
                            onChange={handleChange}
                        />
                        {errorMsg.firstname
                            ? errorMsg.firstname.map((message, key) => {
                                return <Form.Text key={key} className="text-danger">{message}</Form.Text>;
                            })
                            : ""}
                    </Form.Group>
                    <Form.Group controlId="lastname">
                        <Form.Control
                            type="text"
                            placeholder="Enter your Last Name.."
                            name="lastname"
                            value={formData.lastname}
                            onChange={handleChange}
                        />
                        {errorMsg.lastname
                            ? errorMsg.lastname.map((message, key) => {
                                return <Form.Text key={key} className="text-danger">{message}</Form.Text>;
                            })
                            : ""}
                    </Form.Group>
                    <Form.Group controlId="email">
                        <Form.Control
                            type="email"
                            placeholder="Enter your Email Address.."
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                        />
                        {errorMsg.email
                            ? errorMsg.email.map((message, key) => {
                                return <Form.Text key={key} className="text-danger">{message}</Form.Text>;
                            })
                            : ""}
                    </Form.Group>
                    <Form.Group>
                        <div className="sevenWays__FreeReport--recaptcha d-flex justify-content-center">
                                    <Recaptcha checkVerification={handleVerification} />
                        </div>
                        {errorMsg.recaptcha
                            ? errorMsg.recaptcha.map((message, key) => {
                                return <Form.Text key={key} className="text-danger">{message}</Form.Text>;
                            })
                            : ""}
                    </Form.Group>

                    <Button variant="" className="btn btn-free-report" type="button" onClick={onSubmit}>Give me the FREE Report!</Button>
                </Col>
            </Row>
        </Form>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
            <p className="text-center"><small>Your email is safe with us. We'll never sell, rent or give away your details for any reason. Ever!</small></p>
        </Modal.Footer>
    </Modal>
    <style jsx global>{`

            .btn-free-report {
                font-size: 18px;
                background: #f1c40f;    
                color: #2c3e50;
                border: none;
                border-radius: 5px;
                font-weight: 700;
                padding: 15px;
                width: 100%;
            }

        `}</style>
    </>
);
}

export default SignUpForm;